import React,{useEffect, useState} from "react";
import './Navbar.css'

function Navbar() {
    const [show, handleShow] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", ()=>{
            if (window.scrollY>100) {
                handleShow(true)
                
            }else(handleShow(false));
        });
        return () => {
            window.removeEventListener("scroll");
        }
    }, [])

  return (
    <div className={`nav ${show && "nav_black"}`}>
      <img
        className="nav_logo"
        src="http://nativeadvertisinginstitute.com/wp-content/uploads/2015/03/Netflix_Logo_Digital-Video.png"
        alt="Netflix Logo"
      />
      <img
      className="nav_avatar"
        src="https://www.mizrahiorthodontics.com/assets/images/menu-icon.png"
        alt="Menu"
        width="30px"
      />
    </div>
  );
}

export default Navbar;
